export default __webpack_public_path__ + "static/media/like-small.9d68bf3d.svg";